import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type AirlineProductivityAction = ActionType<typeof actions>;

export type AirlineProductivityStatus = "high" | "medium" | "low";

export interface AirlineProductivityItem {
  airline: string;
  isFiltered: boolean;
  clicks: number;
  bookings: number;
  predictedBookings: number;
  productivity: number;
  minimumProductivity: number;
  str: number;
  status: AirlineProductivityStatus;
}

export interface DailyAirlineProductivityItem {
  date: string;
  clicks: number;
  bookings: number;
  predictedBookings: number;
  str: number;
  productivity: number;
}

export enum AirlinesProductivityActionTypes {
  TABLE_FETCH_REQUEST = "@AirlinesProductivity/TABLE_FETCH_REQUEST",
  TABLE_FETCH_SUCCESS = "@AirlinesProductivity/TABLE_FETCH_SUCCESS",
  TABLE_FETCH_ERROR = "@AirlinesProductivity/TABLE_FETCH_ERROR",

  DAILY_FETCH_REQUEST = "@AirlinesProductivity/DAILY_FETCH_REQUEST",
  DAILY_FETCH_SUCCESS = "@AirlinesProductivity/DAILY_FETCH_SUCCESS",
  DAILY_FETCH_ERROR = "@AirlinesProductivity/DAILY_FETCH_ERROR",
}

export interface AirlinesProductivityState {
  readonly count: number;
  readonly isLoading: boolean;
  readonly items: AirlineProductivityItem[];
  readonly dailyItems: Record<string, DailyAirlineProductivityItem[]>;
}

export interface AirlinePayload {
  airline: string;
}

export interface AirlinesProductivityPayload {
  status?: AirlineProductivityStatus[];
}
